function logUserEvent( event )
{
    let sessionId = document.cookie.match(/PHPSESSID=[^;]+/).toString().replace("PHPSESSID=", "");
    let searchValue =   window.SearchBenefits.postcode == '' ? window.SearchBenefits.suburbName :  window.SearchBenefits.postcode;
    let currentStation = jQuery('.stations.active').text().toString().replace("Station", " Station");
    let currentLine = jQuery('.lines.active a').attr("data-line");
    if(currentLine == undefined && jQuery('.lines.active').attr('class') != undefined ){
        currentLine = jQuery('.lines.active').attr('class').replace("col-xs-2 lines ", "").toString().replace("active", "").toString().replace("-", " ");
    }else if(jQuery('.lines.active').attr('class') == undefined){
        currentLine = '';
    }
    let currentTab = jQuery('.accordion-toggle[aria-expanded=true]').text().replace("-", "  ");
    //console.log( " \n Session:" + sessionId , " \n \n Event:" + event , "\n\n Search Value:" + searchValue, "\n Station:" + currentStation , "\n Line:" + currentLine , "\n Tab:" + currentTab );
    let data = { "currentAction":event,"sessionId" : sessionId , "searchValue" : searchValue, "currentStation" : currentStation, "currentLine" : currentLine, "currentTab" : currentTab };
    let check_mate = '';
    if(document.cookie.match(/checkmate_uact=[^;]+/) != undefined){
        check_mate = document.cookie.match(/checkmate_uact=[^;]+/).toString().replace("checkmate_uact=", "");
    }

    fetch(window.location.origin + '/API/uact', {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-Token": check_mate
        },
        method: "POST",
        body: JSON.stringify({ data: data })
    });
    // .then(response => {
    //     return response.text().then(function (text) {
    //         return text ? JSON.parse(text) : {}
    //     })
    // })
    // .then(precinctResultList => {
    //     this.setState({precinctResultList});
    // };
}


